import { forwardRef } from "react";
import Input from "../../../Component/Elements/Input/Input";

interface NameInputInterface{
    value: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    disabled?: boolean;
    readOnly?: boolean;
}

const NameInput = forwardRef<HTMLInputElement, NameInputInterface> (({
    value,
    onBlur,
    onChange,
    disabled,
    readOnly,
}, ref) => {
    return (
        <Input
            type={"text"}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            maxLength={21}
            ref={ref}
            disabled={disabled}
            readOnly={readOnly}
            placeholder={!readOnly && !disabled ? "이름 입력" : undefined}
        />
    )
})

export default NameInput;
